import React from "react";
import { FaBootstrap, FaNodeJs } from "react-icons/fa";
import { SiExpress, SiTailwindcss } from "react-icons/si";
import { FiFigma } from "react-icons/fi";
import { DiPhotoshop } from "react-icons/di";

function SkillSet2() {
  return (
    <>
    <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <FaBootstrap />
        </p>
        {/* <p>Bootstrap - 80%</p> */}
        <p>Bootstrap</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <SiTailwindcss />
        </p>
        {/* <p>Tailwind CSS - 65%</p> */}
        <p>Tailwind CSS</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <FaNodeJs />
        </p>
        {/* <p>Node JS - 65%</p> */}
        <p>Node JS</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <SiExpress />
        </p>
        {/* <p>Express - 60%</p> */}
        <p>Express</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <FiFigma />
        </p>
        {/* <p>Figma - 70%</p> */}
        <p>Figma</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <DiPhotoshop />
        </p>
        {/* <p>Photoshop - 72%</p> */}
        <p>Photoshop</p>
      </div>
    </>
  );
}

export default SkillSet2;
